<template>
<div class="t-margin-bottom-m">
	<div v-if="showBatchSuccessMessage" class="c-competence-cards-batch-page__message t-margin-bottom-m">
		<h1 class="t-text-style-beta">Kursen har lagts till.</h1>
		<button @click="closeSuccessMessage" class="c-button c-button--primary t-margin-top-s t-margin-bottom-s">Lägg till kurs för flera medarbetare</button>
	</div>
	<form v-else @submit.prevent="batchAddCourses" class="c-form  t-margin-top-s">
		<div class="[ c-island c-island--large@lg ] t-background-white-grey t-margin-bottom-s">
			<h2 class="t-text-style-beta t-margin-left-s t-margin-right-s t-margin-top-s">1. Ange kurs</h2>
			<div class="t-margin-top-s t-margin-left-s t-margin-right-s t-margin-bottom-s">
				<div class="c-buffer-box c-buffer-box--vertical c-buffer-box--super-tight-top-ends t-border-green">
					<fieldset>
						<div class="o-grid">
							<div data-size="sm:12 md:12 lg:12" class="o-grid__column t-margin-bottom-s">
								<fieldset class="c-radio-group" ref="courseType">
									<div class="c-radio c-radio--inline">
										<input type="radio" name="type" :checked="courseType !== 'Certification'" value="Course" class="c-radio__input" id="course">
										<label for="course" class="c-radio__label">Kurs</label>
									</div>
									<div class="c-radio c-radio--inline">
										<input type="radio" name="type" :checked="courseType === 'Certification'" value="Certification" class="c-radio__input" id="certification">
										<label for="certification" class="c-radio__label">Certifikat</label>
									</div>
								</fieldset>
							</div>
							<div data-size="sm:12 md:4 lg:4" class="o-grid__column t-margin-bottom-s">
								<dropdown-variations :item-groups="courseOptions" label="Välj kurskategori" :value="category" ref="category"  :allow-custom-value="true" :filterable="true"></dropdown-variations>
							</div>
							<div data-size="sm:12 md:8 lg:8" class="o-grid__column t-margin-bottom-xs">
								<div class="c-form__item">
									<vue-input label="Namn på kurs/certifiering" :input-id="'name-' + id" :value="name" ref="name"></vue-input>
								</div>
							</div>
							<div data-size="sm:12 md:6 lg:6" class="o-grid__column t-margin-bottom-xs">
								<div class="c-form__item">
									<vue-input label="Utfärdare/Arrangör" :input-id="'issuer-' + id" :value="issuer" ref="issuer"></vue-input>
								</div>
							</div>
							<div data-size="sm:12 md:6 lg:6" class="o-grid__column t-margin-bottom-xs">
								<div class="c-form__item">
									<date-input label="Kurs-/utfärdandedatum (åååå-mm-dd)" :input-id="'issued-' + id" :value="issued" ref="issued"></date-input>
								</div>
							</div>
							<div data-size="sm:12 md:12 lg:12" class="o-grid__column t-margin-bottom-s">
								<fieldset class="c-radio-group" ref="validTo">
									<div class="o-grid  c-coworker-course__radiogroup">
										<div class="c-radio t-margin-right-s">
											<input type="radio" name="validyToDate" v-on:change="shouldInputBeEnabled" :checked="!expires || (validTo && validTo.type && validTo.type === 'UntilFurtherNotice')" class="c-radio__input" id="permanent" value="UntilFurtherNotice">
											<label for="permanent" class="c-radio__label">Giltig tills vidare</label>
										</div>
										<div class="c-radio t-margin-right-s">
											<input type="radio" name="validyToDate" v-on:change="shouldInputBeEnabled" :checked="expires || (validTo && validTo.type && validTo.type === 'ExpiresAt')" value="ExpiresAt" class="c-radio__input" id="date">
											<label for="date" class="c-radio__label">Giltig till datum</label>
										</div>
										<date-input label="Datum (åååå-mm-dd)" :required="enableInput" :disabled="!enableInput" :input-id="'date-' + id" :value="expires" ref="date"></date-input>
									</div>
								</fieldset>
							</div>
							<div data-size="sm:12 md:12 lg:12" class="o-grid__column">
								<vue-input
									type="checkbox"
									label="Visa på kompetenskort"
									inputId="printOption"
									:checked="true"
									ref="printOption">
								</vue-input>
							</div>
						</div>
					</fieldset>
				</div>
			</div>
		</div>
		<div class="[ c-island c-island--large@lg ] t-background-white-grey t-margin-bottom-s">
			<h2 class="t-text-style-beta t-margin-left-s t-margin-right-s t-margin-top-xs">2. Välj medarbetare</h2>
			<div class="t-margin-top-s t-margin-left-s t-margin-right-s t-margin-bottom-s">
				<div class="t-margin-top-m t-margin-bottom-s t-margin-left-s">
					<div class="c-checkbox">
						<input id="selectAll" type="checkbox" class="c-checkbox__input" :checked="selectAllChecked" @input="toggleAll" />
						<label for="selectAll" class="c-checkbox__label">Välj alla</label>
					</div>
				</div>
				<table class="c-list-component t-background-white-grey">
					<tr v-for="competenceCard in $data.$_competenceCards" :key="competenceCard.id" class="c-list-row t-background-white">
						<td class="c-list-item c-list-item--default">
							<div class="c-checkbox">
								<input :id="`competenceCard-${competenceCard.id}`" type="checkbox" :value="`competenceCardId-${competenceCard.id}`" :checked="competenceCard.selected" @change="onCompetenceCardCheckChange(competenceCard)" class="c-checkbox__input" name="competenceCard" />
								<label :for="`competenceCard-${competenceCard.id}`" class="c-checkbox__label"></label>
							</div>
						</td>
						<td class="c-list-item c-list-item--default">
							<span class="c-list-item__label">Namn</span>
							<p class="t-text-style-epsilon">{{ competenceCard.basicInformation.firstName }} {{ competenceCard.basicInformation.surName }}</p>
						</td>
						<td class="c-list-item c-list-item--default">
							<span class="c-list-item__label">Anställd som</span>
							<p class="t-text-style-epsilon">{{ competenceCard.basicInformation.role || '&nbsp;' }}</p>
						</td>
					</tr>
				</table>
			</div>
		</div>
		<div class="t-margin-bottom-m t-margin-top-m t-text-align-right">
			<button class="c-button c-button--primary" type="submit">Spara</button>
		</div>
	</form>
</div>
</template>

<script>
import VueInput from '@/components/vue-components/vue-input/VueInput.vue';
import DateInput from '@/components/vue-components/date-input/DateInput.vue';
import Modal from '@/components/vue-components/modal/Modal.vue';
import DropdownVariations from '@/components/vue-components/dropdown-variations/DropdownVariations.vue';
import ListComponent from '@/components/vue-components/list-component/ListComponent.vue';

export default {
    name: 'CompetenceCardBatchCourse',
    components: {
		VueInput,
		DateInput,
        Modal,
		DropdownVariations,
		ListComponent
    },
    props: {
        mode: {
            type: String,
            default: ''
        },
        competenceCardId: {
            type: String,
            default: '0'
        },
        id: {
            type: String,
            default: '0'
        },
        name: {
            type: String,
            default: ''
        },
        category: {
            type: String,
            default: ''
        },
        courseType: {
            type: String,
            default: ''
        },
        issuer: {
            type: String,
            default: ''
        },
        issued: {
            type: String,
            default: ''
		},
		expires: {
			type: String,
			default: ''
		},
        validTo: {
            type: Object,
            default: () => {}
        },
		courseOptions: {
			type: Array,
			default: () => []
		},
		competenceCards: {
			type: Array,
			default: () => []
		},
		showBatchSuccessMessage: {
			type: Boolean,
			default: false
		}
    },
    data() {
        return {
			showDeleteModal: false,
			enableInput: false,
			$_competenceCards: []
        }
	},
	watch: {
		competenceCards: {
			deep: true,
			immediate: true,
			handler () {
				this.$data.$_competenceCards =
					this.competenceCards
						.map(competenceCard => Object.assign({}, competenceCard, { selected: false }));

			}
		}
	},
	computed: {
		selectAllChecked () {
			return this.$data.$_competenceCards.every(competenceCard => competenceCard.selected);
		},
		selectedCompetenceCards () {
			return this.$data.$_competenceCards.filter(competenceCard => competenceCard.selected);
		}
	},
    methods: {
        batchAddCourses() {
            this.$emit('addCourseBatch', {
				competenceCards: this.selectedCompetenceCards.map(competenceCard => competenceCard.id),
                name: this.$refs.name.getValue(),
                category: this.$refs.category.getValue(),
                courseType: this.$refs.courseType.querySelector('input[name="type"]:checked').value,
                issuer: this.$refs.issuer.getValue(),
				issued: this.$refs.issued.getValue(),
				expires: this.$refs.date.getValue(),
				printOption: (this.$refs.printOption.getValue()) ? 'Display' : 'Hide'
            });
        },
		shouldInputBeEnabled(event) {
			let type = event.target.value;
			this.enableInput = (type === 'ExpiresAt');
			this.validTo = { type: type };
			if (event.target.value === 'ExpiresAt') {
				this.validTo = { type: 'ExpiresAt' };
				this.enableInput = true;
			} else {
				if(this.validTo) this.validTo.date = '';
				this.expires = this.validTo.date;
				this.enableInput = false;
			}
			return this.enableInput;
		},
		closeSuccessMessage() {
			this.$emit('closeSuccessMessage');
		},

		toggleAll (e) {
			this.$data.$_competenceCards.forEach(competenceCard =>
				competenceCard.selected = e.target.checked
			);
		},

		onCompetenceCardCheckChange (competenceCard) {
			competenceCard.selected = !competenceCard.selected;
		}
	},
	created() {
		if (this.expires) {
			this.enableInput = true;
		}
	}
}
</script>
